// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1097":"17787966","3971":"27598b0e","5281":"7ac6a1a1"}[chunkId] + ".chunk.css";
};